const redirectUri = process.env.REACT_APP_REDIRECT_URL;
const Youtube = {
  authorizeUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
  clientId: '392294599757-7vic9peaib6qai7olqvqj007v3pgjso7.apps.googleusercontent.com',
  redirectUri: `${redirectUri}/youtube-redirect`,
  scope: 'https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/yt-analytics.readonly',
};
const Threads = {
  authorizeUrl: 'https://threads.net/oauth/authorize',
  clientId: 592005970612329,
  redirectUri: `${redirectUri}/threads-redirect`,
  scope: 'threads_basic,threads_content_publish',
};

const GoogleMyBusiness = {
  authorizeUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
  clientId: '392294599757-nqlelkduf631bareqcg1q3ks5t65a0ne.apps.googleusercontent.com',
  redirectUri: `${redirectUri}/gbusiness-redirect`,
  scope: 'https://www.googleapis.com/auth/business.manage',
};
const Instagram = {
  authorizeUrl: 'https://www.facebook.com/v23.0/dialog/oauth',
  appId: 1075601064430497,
  redirectUri: `${redirectUri}/instagram-redirect`,
  scope: 'pages_show_list,pages_messaging,pages_manage_metadata,pages_read_engagement,instagram_basic,instagram_manage_messages,business_management',
  state: true,
  xfbml: true,
  cookie: true,
  version: 'v23.0',
  responseType: 'code',
  SDK_URL: 'https://connect.facebook.net/en_US/sdk.js',
  SCRIPT_ID: 'instagram-jssdk',
};
const Facebook = {
  appId: 1075601064430497,
  redirectUri: `${redirectUri}/facebook-redirect`,
  scope: 'pages_show_list,pages_messaging,pages_manage_metadata,pages_read_engagement,business_management',
  state: true,
  xfbml: true,
  cookie: true,
  version: 'v23.0',
  responseType: 'code',
  SDK_URL: 'https://connect.facebook.net/en_US/sdk.js',
  SCRIPT_ID: 'facebook-jssdk',
};
const WhatsApp = {
  appId: 1075601064430497,
  embeddedSignupConfigId: '1481436223821619',
  redirectUri: `${redirectUri}/whatsapp-redirect`,
  version: 'v23.0',
  SDK_URL: 'https://connect.facebook.net/en_US/sdk.js',
  SCRIPT_ID: 'facebook-jssdk',
};
const LinkedIn = {
  authorizeUrl: 'https://www.linkedin.com/oauth/v2/authorization',
  clientId: '86b3vqsgm6yplu',
  redirectUri: `${redirectUri}/linkedin-redirect`,
  scope: "r_basicprofile,r_organization_social,w_member_social,w_organization_social,rw_organization_admin,profile",
  state: 123456
};
const Stripe = {
  clientId:'pk_live_51NsJleSHFbhO2NgA1fUCahPcroz7FN4KeVHIasIJLQx5pU6lKjBdWTfHK4AQRhoEichjelohFDxv3fIpcLTO95If00PPi9GtwK',
  //clientId:'pk_test_51Tl1WOFrofPBKi2fKdSexGjrYrfNRdxnE6lTUI6nvWLuZJg26YhkvGzihanic71QEuirag27swx6vrnadzl1NouY00hAMJ7Xg9',
  redirectUri: `${redirectUri}/payment-redirect`,
};
const GoogleSignIn = {
  authorizeUrl: "https://accounts.google.com/o/oauth2/v2/auth",
  clientId: "89585937659-rvrfqvvkrfv4kptv8n0k9rvpgbivpqd9.apps.googleusercontent.com",
  redirectUri: `${redirectUri}/google-redirect`,
  scope: 'openid%20profile%20email'
};
const Tiktok = {
  authorizeUrl: "https://www.tiktok.com/v2/auth/authorize",
  clientId: "awlze1s3235okd0z",
  scope: "user.info.basic,user.info.profile,user.info.stats,video.publish,video.upload,video.list",
  responseType: "code",
  redirectUri: `${redirectUri}/tiktok-redirect`
}
const Pinterest = {
  authorizeUrl: 'https://www.pinterest.com/oauth/',
  clientId: '1504526',
  redirectUri: `${redirectUri}/pinterest-redirect`,
  scope : "boards:read,boards:read_secret,boards:write,boards:write_secret,pins:read,pins:read_secret,pins:write,pins:write_secret,user_accounts:read"
};
const Snapchat = {
  authorizeUrl: 'https://accounts.snapchat.com/login/oauth2/authorize',
  clientId: 'a00c836c-c844-4aef-a3a7-ac214fb70d04',
  redirectUri: `${redirectUri}/snapchat-redirect`,
  scope : "snapchat-profile-api"
};
const Common = {
  notificationInterval: 60000,
  socialAccountsIntegrationInterval: 2000
};
const Maintainance = {
  StartTime: "12/06/2025 8:50 pm", //DD/MM/YY HH:mm // 12 hours format
  EndTime: "12/06/2025 9:30 pm"
}
export const Config = {
  Youtube,
  Threads,
  GoogleMyBusiness,
  Stripe,
  Instagram,
  Facebook,
  WhatsApp,
  Common,
  LinkedIn,
  Pinterest,
  GoogleSignIn,
  Tiktok,
  Maintainance,
  Snapchat
};



